module.exports = __webpack_public_path__ + "static/media/Color-squad.971d12fb.png";